var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useLocale } from '../../communication';
import { t } from '@mp/locale';
import { getCurrencySymbol } from "../utils";
import './Surcharge.scss';
export default function Surcharge(_a) {
    var order = _a.order;
    var price_line_items = order.price_line_items;
    var language = useLocale().language;
    if (!Array.isArray(price_line_items) || price_line_items.length === 0) {
        return null;
    }
    var discountIndex = price_line_items.findIndex(function (p) { return p.type === 'CONTRACT_DISCOUNT'; });
    var endOfSurcharges = price_line_items.length + 1;
    var startOfSurcharges = discountIndex + 1;
    var surcharges = price_line_items.slice(startOfSurcharges, endOfSurcharges);
    if (!surcharges.length) {
        return null;
    }
    return (_jsx("div", __assign({ className: "mp-capturesvc-review-surcharges review-info-item review-pricing" }, { children: _jsxs("div", __assign({ className: "item-details" }, { children: [_jsx("div", __assign({ className: "item-title" }, { children: t("CAPTURE_SERVICES.ORDER.REVIEW.surcharges") })), surcharges
                    .filter(function (price) { return Boolean(price.type); })
                    .map(function (price, index) {
                    var _a;
                    return (_jsxs("div", __assign({ className: "mp-capturesvc-review-surcharges-item" }, { children: [_jsx("div", { children: t("CAPTURE_SERVICES.ORDER.REVIEW.SURCHARGE_ITEMS.".concat(price.type), price === null || price === void 0 ? void 0 : price.description) }), _jsx("div", { children: _jsxs("strong", { children: [getCurrencySymbol(order === null || order === void 0 ? void 0 : order.estimate_currency), (_a = price === null || price === void 0 ? void 0 : price.amount) === null || _a === void 0 ? void 0 : _a.toLocaleString(language, { minimumFractionDigits: 2 })] }) })] }), "".concat(price.amount, "-").concat(price.price, "-").concat(index)));
                })] })) })));
}
